import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "./theme";
import { CssBaseline } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { CreateRoutes } from "./routes";
import { Toaster } from "react-hot-toast";
import { toastOptions } from "resources/constants";
import { createContext, useEffect, useReducer } from "react";
import { appContextInitialState, AppReducer } from "shared/helpers/AppContext";
import "antd/dist/reset.css";
import { isSessionExpired } from "shared/helpers/isSessionExpired";

export const GlobalContext = createContext(null);

const CHECK_SESSION_INTERVAL = 60000

function App() {
  const [contextInitialState, dispatchContext] = useReducer(
    AppReducer,
    appContextInitialState
  );
  const router = CreateRoutes();
  const theme = createTheme();

  useEffect(() => {
    const checkInterval = setInterval(() => {
      if (isSessionExpired()) {
        window.location.assign('/login');
      }
    }, CHECK_SESSION_INTERVAL);

    return () => clearInterval(checkInterval);
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={theme}>
        <GlobalContext.Provider
          value={{ contextInitialState, dispatchContext }}
        >
          <CssBaseline />
          <Toaster position="top-center" toastOptions={toastOptions} />
          <RouterProvider router={router} />
        </GlobalContext.Provider>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
